export const STOCK_SET_CURRENT = 'STOCK_SET_CURRENT';
export const STOCK_SET_LIST = 'STOCK_SET_LIST';
